function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import React, { useCallback, useEffect, useState } from 'react';
import { buildService } from '../service';
const api = buildService('/claim_groups/{id}/project_overview_import', {
  only: ['get']
}, {
  only: ['postFormData']
});
const initialParams = {
  page: 1,
  order_by: 'report_order',
  group_projects: 'default',
  query: ''
};
const projectImportService = {
  useImportStatus(claimGroupId, getData) {
    const [importStatus, setImportStatus] = useState({});
    const [intervalId, setIntervalId] = useState(null);
    const getImportStatus = useErrorHandling(useCallback(async shouldGetData => {
      const response = await projectImportService.get(claimGroupId);
      if (response === null) {
        setImportStatus({
          import_status: 'never_imported'
        });
      } else {
        setImportStatus(_objectSpread({}, response));
      }
      if ((response === null || response === void 0 ? void 0 : response.import_status) !== 'pending' && shouldGetData) {
        await getData(initialParams);
      }
      return response;
    }, [getData, claimGroupId]));
    useEffect(() => {
      if (importStatus.import_status === 'pending' && !intervalId) {
        const currentId = setInterval(() => {
          getImportStatus();
        }, 2000);
        setIntervalId(currentId);
      } else if (importStatus.import_status !== 'pending' && !!intervalId) {
        getImportStatus(true);
        clearInterval(intervalId);
        setIntervalId(null);
      }
      return () => {
        clearInterval(intervalId);
      };
    }, [getImportStatus, importStatus.import_status, intervalId, claimGroupId]);
    useEffect(() => {
      /** Please dont ever do it like I did it here. This is a quickfix to fix a bug in production before a call with a client. */
      if (claimGroupId && process.env.PUBLIC_URL === '/be') {
        getImportStatus();
      }
    }, [claimGroupId, getImportStatus]);
    return [importStatus, setImportStatus];
  },
  get(claimGroupId) {
    return api.get(claimGroupId);
  },
  useImportProjects(claimGroupId, setImportStatus) {
    const importProjects = useErrorHandling(useCallback(async body => {
      const response = await api.postFormData(claimGroupId, body);
      setImportStatus(_objectSpread({}, response));
    }, [setImportStatus, claimGroupId]));
    return importProjects;
  }
};
projectImportService.useCrud = (claimGroupId, getData) => {
  const [importStatus, setImportStatus] = projectImportService.useImportStatus(claimGroupId, getData);
  const importProjects = projectImportService.useImportProjects(claimGroupId, setImportStatus);
  return {
    importStatus,
    importProjects
  };
};
export default projectImportService;